import { render, staticRenderFns } from "./ParagraphElement.vue?vue&type=template&id=72f95810&"
import script from "./ParagraphElement.vue?vue&type=script&lang=js&"
export * from "./ParagraphElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports